import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../../services/api';

function Dashboard() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    async function loadStats() {
      try {
        const [userStats] = await Promise.all([
          api.getUserStats(),
          api.getRecipes({ limit: 1 }),
        ]);
        setStats(userStats);
      } catch {
        // Dashboard-Statistiken sind optional — kein Error-State nötig
      }
    }
    loadStats();
  }, []);

  return (
    <div className="admin-dashboard">
      <h1>Dashboard</h1>
      <p className="sub">Willkommen im Strixly Admin-Bereich.</p>

      {stats && (
        <>
          <p className="admin-section-title">Übersicht</p>
          <div className="admin-stats">
            <div className="admin-stat">
              <div className="admin-stat-val">{stats.total_users ?? '—'}</div>
              <div className="admin-stat-label">Benutzer</div>
            </div>
            <div className="admin-stat">
              <div className="admin-stat-val">{stats.total_admins ?? '—'}</div>
              <div className="admin-stat-label">Admins</div>
            </div>
          </div>
        </>
      )}

      <p className="admin-section-title">Schnellzugriff</p>
      <div className="admin-grid">
        <a href="/editor" className="admin-card">
          <div className="admin-card-icon">🎨</div>
          <div className="admin-card-title">Layout-Editor</div>
          <div className="admin-card-desc">Seiten gestalten, Blöcke anordnen, Farben & Fonts</div>
        </a>
        <Link to="/admin/users" className="admin-card">
          <div className="admin-card-icon">👥</div>
          <div className="admin-card-title">Benutzer</div>
          <div className="admin-card-desc">Benutzer verwalten, Rollen zuweisen</div>
        </Link>
        <Link to="/admin/recipes/new" className="admin-card">
          <div className="admin-card-icon">➕</div>
          <div className="admin-card-title">Neues Rezept</div>
          <div className="admin-card-desc">Rezept manuell erstellen</div>
        </Link>
        <Link to="/upload" className="admin-card">
          <div className="admin-card-icon">📷</div>
          <div className="admin-card-title">Foto-Upload</div>
          <div className="admin-card-desc">Rezept per Foto hochladen & erkennen</div>
        </Link>
      </div>
    </div>
  );
}

export default Dashboard;
